import { getAllRightList } from '@/api/right'

export const namespaced = true

export const state = () => ({
  allRightList: []
})

export const getters = {
  hasRight: state => productId => {
    return !!~state.allRightList.findIndex(item => item.productId === productId)
  },
  rightInfo: state => productId => {
    return state.allRightList.find(item => item.productId === productId)
  }
}

export const mutations = {
  setAllRightList: function(state, allRightList) {
    state.allRightList = allRightList
  }
}

export const actions = {
  async getAllRightList({ state, commit }, flush = true) {
    if (flush || !state.allRightList) {
      const allRightList = await getAllRightList()

      commit('setAllRightList', allRightList)
    }
  }
}
